<template>
  <table class="table table-striped table-bordered table-condensed">
    <thead>
      <tr>
        <th><div class="text-center">Account Name</div></th>
        <th class="hidden-phone"><div class="text-center">E-mail</div></th>
        <th class="hidden-tablet"><div class="text-center">Real Name</div></th>
        <th class="hidden-tablet"><div class="text-center">Organization</div></th>
        <th><div class="text-center">User Privilege</div></th>
        <th v-if="showActions"><div class="text-center">Operation</div></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="row in rows" :key="`user-${row.id}`" :class="{ danger: row.locked }">
        <td><div class="text-center"><a :href="row.show_url">{{ row.login }}</a></div></td>
        <td class="hidden-phone"><div class="text-center">{{ row.email }}</div></td>
        <td class="hidden-tablet"><div class="text-center">{{ row.realname }}</div></td>
        <td class="hidden-tablet"><div class="text-center">{{ row.organization }}</div></td>
        <td><div class="text-center">{{ row.privilege }}</div></td>
        <td v-if="showActions" v-html="row.action_html"></td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  initialData: {
    type: Object,
    default: () => ({ rows: [] })
  }
})

const rows = computed(() => props.initialData?.rows || [])
const showActions = computed(() => rows.value.some((row) => row.action_html))
</script>
